import { useMemo } from 'react';
import { productionEnvironment, useBuddi } from '@bentley/pw-config';
import { useConfigContext } from '../../../context';
import { createDatasourceEncodedSelectionStateFromUrlParams } from '../../../services/encode/encode';

export function useWebViewLink(cannedConnection?: boolean): string {
  const { config } = useConfigContext();

  let webViewUrl = useBuddi('ProjectwiseWebView.URL', config.BUDDIRegionCode);
  // configure url to work for release environments
  if (productionEnvironment() == 'release') {
    if (webViewUrl) {
      const webViewUrlParts = webViewUrl.split('-');
      webViewUrl =
        'https://qa-release-' +
        webViewUrlParts.slice(1, webViewUrlParts.length).join('-');
    }
  }

  const encodedSelectionState =
    createDatasourceEncodedSelectionStateFromUrlParams();

  const webViewLink = useMemo((): string => {
    if (!encodedSelectionState || !webViewUrl || cannedConnection) {
      return '';
    }

    const baseUrl =
      productionEnvironment() == 'localhost' &&
      config.DataAccessLevel == 'Datasource'
        ? window.location.origin
        : webViewUrl;

    const webViewLink = `${baseUrl}?link=${encodedSelectionState}`;
    return webViewLink;
  }, [
    cannedConnection,
    config.DataAccessLevel,
    encodedSelectionState,
    webViewUrl
  ]);

  return webViewLink;
}
